import React from 'react'
import './style.css'

const TableHeadRowStart = ({ text }) => {
  return (
    <th style={{ whiteSpace: "nowrap", paddingLeft: 10, paddingRight: 10, color: 'var(--app-heading)' }}>{text}</th>
  )
}

export default TableHeadRowStart